// components/Header/UserInfo.jsx
import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useUser } from '../../context/UserContext';

export const useUserInitials = () => {
  const { user } = useAuth();
  const { userData } = useUser();

  if (!user) return '?';
  
  if (userData?.firstName) {
    return userData.firstName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
  
  return user.email?.[0]?.toUpperCase() || '?';
};

export const UserInfo = ({ variant = 'desktop' }) => {
  const { user } = useAuth();
  const initials = useUserInitials();
  const isMobile = variant === 'mobile';

  return (
    <Box
      sx={{
        px: 2,
        py: isMobile ? 2 : 1,
        ...(isMobile && { display: 'flex', alignItems: 'center', gap: 2 }),
      }}
    >
      {isMobile && (
        <Avatar
          sx={{
            width: 48,
            height: 48,
            bgcolor: 'secondary.main',
            fontWeight: 600,
          }}
        >
          {initials}
        </Avatar>
      )}
      <Box>
        <Typography
          variant={isMobile ? 'subtitle1' : 'subtitle2'}
          fontWeight="600"
          sx={{ fontFamily: 'Inter, sans-serif' }}
        >
          {user?.displayName || 'User'}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontFamily: 'Inter, sans-serif',
            ...(isMobile && { wordBreak: 'break-all' }),
          }}
        >
          {user?.email}
        </Typography>
      </Box>
    </Box>
  );
};